<template>
  <el-container class="index-con" :class="layoutClass">
    <div v-if="compact && asideOpen" class="side-mask" @click="closeAside"></div>
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main class="index-main">
        <router-view></router-view>
      </el-main>
      <el-footer class="index-footer" height="40px">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">吉ICP备2026010258号</a>
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      compact: false,
      phoneLand: false,
      tabletLand: false,
      asideOpen: true
    }
  },
  computed: {
    layoutClass() {
      return {
        'is-compact': this.compact,
        'aside-open': this.asideOpen,
        'is-phone-land': this.phoneLand,
        'is-tablet-land': this.tabletLand
      }
    }
  },
  components: {
    navcon,
    leftnav
  },
  created() {
    this.$root.Bus.$on('toggle', value => {
      this.asideOpen = !!value
      this.showclass = value ? 'asideshow' : 'aside'
    })
  },
  mounted() {
    this.syncLayout()
    window.addEventListener('resize', this.syncLayout)
    window.addEventListener('orientationchange', this.onOrient)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncLayout)
    window.removeEventListener('orientationchange', this.onOrient)
  },
  methods: {
    onOrient() {
      setTimeout(this.syncLayout, 80)
    },
    syncLayout() {
      const w = window.innerWidth
      const h = window.innerHeight
      const land = w > h
      const phoneLand = land && h <= 540
      const tabletLand = land && w >= 768 && w <= 1366 && h > 540
      const compact = w < 960 || phoneLand
      const wasCompact = this.compact
      this.phoneLand = phoneLand
      this.tabletLand = tabletLand
      this.compact = compact
      if (compact && !wasCompact) {
        this.asideOpen = false
        this.showclass = 'aside'
        this.$root.Bus.$emit('toggle', false)
      }
      if (!compact && wasCompact) {
        this.asideOpen = true
        this.showclass = 'asideshow'
        this.$root.Bus.$emit('toggle', true)
      }
    },
    closeAside() {
      this.$root.Bus.$emit('toggle', false)
    }
  }
}
</script>
<style>
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}
.aside {
  width: 64px !important;
  height: 100%;
  background: linear-gradient(180deg, #21164a 0%, #3b1d6e 55%, #5b67f1 160%);
  margin: 0;
  overflow: hidden;
}
.asideshow {
  width: 228px !important;
  height: 100%;
  background: linear-gradient(180deg, #21164a 0%, #3b1d6e 55%, #5b67f1 160%);
  margin: 0;
  overflow-x: hidden;
}
.main-con {
  background: #f4f1ff;
  min-width: 0;
}
.index-header {
  padding: 0;
  height: 64px !important;
}
.index-main {
  padding: 20px 24px;
  overflow: auto;
  min-width: 0;
  background:
    radial-gradient(900px 280px at 0% 0%, rgba(255, 107, 107, 0.12), transparent 55%),
    radial-gradient(700px 240px at 100% 0%, rgba(91, 103, 241, 0.16), transparent 50%),
    #f4f1ff;
}
.index-footer {
  padding: 0;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: transparent;
}
.index-footer a {
  color: #8a8299;
  font-size: 12px;
  text-decoration: none;
}
.index-footer a:hover {
  color: #5b67f1;
}
.side-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(27, 20, 51, 0.42);
  z-index: 1990;
}
.index-con.is-compact > .el-aside {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 2000;
  height: 100% !important;
}
.index-con.is-compact .main-con {
  margin-left: 64px;
}
.index-con.is-compact.aside-open > .el-aside {
  box-shadow: 10px 0 28px rgba(27, 20, 51, 0.28);
}

@media (orientation: landscape) and (max-height: 540px) {
  .index-header {
    height: 48px !important;
  }
  .index-main {
    padding: 10px 12px 12px;
  }
  .index-footer {
    display: none;
  }
  .index-con.is-compact .main-con {
    margin-left: 52px;
  }
  .index-con.is-phone-land .aside {
    width: 52px !important;
  }
}

@media (orientation: landscape) and (min-width: 768px) and (max-width: 1366px) {
  .asideshow {
    width: 196px !important;
  }
  .index-header {
    height: 56px !important;
  }
  .index-main {
    padding: 14px 16px;
  }
  .index-footer {
    height: 32px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue